<template>
  <div class="footer my-5 rounded bg-white">
    <div class="row">

      <div class="col-12 col-lg-6">
        <div class="rounded p-3 text-secondary">
          <p>درباره ما</p>
          <p class="text-secondary text-justify">
            {{ basicSiteInfos?.aboutUs }}
          </p>

        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="rounded p-3 text-secondary">
          <p>اطلاعات تماس</p>
          <p class="text-secondary">
            آدرس :
            <span> {{ basicSiteInfos?.companyAddress }} </span>
          </p>
          <p>شماره تماس</p>
          <ul class="pe-3 text-secondary">
            <li><span>مدیریت :‌ </span>{{ basicSiteInfos?.companyPhone1 }}</li>
            <li v-if="basicSiteInfos?.companyPhone2">
              <span>شرکت :‌ </span>{{ basicSiteInfos?.companyPhone2 }}
            </li>
            <li v-if="basicSiteInfos?.companyPhone3">
              <span>دفتر بارنامه نویسی :‌ </span>{{ basicSiteInfos?.companyPhone3 }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <h5 class="border border-primary rounded-pill px-3 mx-auto py-0 text-center fw-light fs-7"
    style="width: max-content;">طراحی شده توسط <span class="text-white rounded-pill fw-light py-0"><a
        href="https://phproject.ir" class="text-primary">ققنوس</a></span></h5>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  basicSiteInfos: {
    type: Object,
    required: true
  }
});
</script>

<style></style>
